import React from "react"

export default function FormInputLabel({ id, label, required = false }) {
  return (
    <label htmlFor={id} className="form-label">
      <span className="form-label__text">
        {label}
        {required && <span aria-hidden="true">*</span>}
      </span>
    </label>
  )
}
